import type { FC, SVGProps } from 'react';

export const ChevronDownIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.03345 3.85742C3.13586 3.85746 3.23199 3.9079 3.29224 3.99023L9.00024 11.8564L14.7073 3.99023C14.7675 3.90795 14.8637 3.85752 14.9661 3.85742H16.4729C16.6034 3.85742 16.68 4.00584 16.6018 4.1123L9.51782 13.8779C9.26267 14.2312 8.73687 14.2313 8.47974 13.8779L1.39575 4.1123C1.31968 4.00585 1.39613 3.85743 1.52661 3.85742H3.03345Z"
    />
  </svg>
);
